module.exports = __webpack_public_path__ + "img/mn.452fb2c8.svg";